function unwrapAttributes(entity) {
  if (!entity) return null;
  if (entity.attributes) {
    return { id: entity.id, ...entity.attributes };
  }
  return entity;
}

function normalizeMedia(relation) {
  if (!relation) return null;
  const data = relation.data ?? relation;
  if (!data) return null;
  const attrs = data.attributes ?? data;
  const url = attrs?.url;
  return url ? { url } : null;
}

export function normalizeMateria(entry) {
  if (!entry) return null;
  const flat = unwrapAttributes(entry);
  return {
    id: flat.id,
    Titulo: flat.Titulo ?? "",
    Horas: Number(flat.Horas) || 0,
    Creditos: Number(flat.Creditos) || 0,
    Semestre: Number(flat.Semestre) || 0,
    Fase: flat.Fase ?? "",
    Trayecto: flat.Trayecto ?? "",
    Orden: Number(flat.Orden) || 1,
    SpanTrayectos: Number(flat.SpanTrayectos) || 1,
  };
}

function normalizeMateriasList(mallaBlock) {
  if (!mallaBlock) return [];
  const raw =
    mallaBlock.Materias?.data ??
    mallaBlock.Materias ??
    mallaBlock.materias?.data ??
    mallaBlock.materias ??
    [];
  const list = Array.isArray(raw) ? raw : [];
  return list.map(normalizeMateria).filter(Boolean);
}

function normalizeMallaCurricular(mallaRelation) {
  const malla = unwrapAttributes(mallaRelation?.data ?? mallaRelation);
  if (!malla) {
    return { Vigencia: "", Titulo: "Malla curricular", Materias: [] };
  }
  return {
    Vigencia: malla.Vigencia ?? "",
    Titulo: malla.Titulo ?? "Malla curricular",
    Materias: normalizeMateriasList(malla),
  };
}

/**
 * @param {object} strapiPayload - Strapi REST `{ data: { id, attributes } }`
 * @returns {{ id: number, attributes: object }}
 */
export function normalizeLicenciaturaResponse(strapiPayload) {
  const root = strapiPayload?.data ?? strapiPayload;
  const flat = unwrapAttributes(root);
  if (!flat) {
    return { id: null, attributes: null };
  }

  const mallaRaw =
    flat.MallaCurricular?.data ?? flat.MallaCurricular ?? flat.mallaCurricular;

  return {
    id: flat.id ?? root?.id ?? null,
    attributes: {
      Nombre: flat.Nombre ?? "",
      Descripcion: flat.Descripcion ?? "",
      Informacion: flat.Informacion ?? null,
      Informacion2: flat.Informacion2 ?? null,
      ImagenLicenciatura: normalizeMedia(flat.ImagenLicenciatura),
      MallaCurricular: normalizeMallaCurricular(mallaRaw ?? flat.MallaCurricular),
    },
  };
}
